export type DisplayConditionFieldConfig = {
  fieldName: string;
  label: string;
  placeholder: {
    allow: string;
    deny: string;
  };
  type: "single" | "multiple";
  description?: string;
  parser?: string;
};

export type DisplayConditionFieldsConfig = {
  [key: string]: DisplayConditionFieldConfig;
};

export type builtDisplayConditionBaseType = {
  user_state?: string;
  country?: string | string[];
  locale?: string | string[];
  device_platform?: string | string[];
  device?: string; // legacy fallback support
  domain?: string | string[];
  abtest?: string;
  currency?: string | string[];
  vip_status?: string | string[];
  tags?: string | string[];
  btag?: string | string[];
};

export type builtDisplayConditionType = builtDisplayConditionBaseType & {
  deny?: builtDisplayConditionBaseType;
};

export type parsedDisplayConditionRuleType = {
  user_state: string;
  country: string[];
  locale: string[];
  device_platform: string[];
  domain: string[];
  abtest: string;
  currency: string[];
  vip_status: string[];
  tags: string[];
  btag: string[];
};

export type parsedDisplayConditionType = {
  allow: parsedDisplayConditionRuleType;
  deny: parsedDisplayConditionRuleType;
};

export const displayConditionRuleValues: parsedDisplayConditionRuleType = {
  user_state: null,
  country: [],
  locale: [],
  device_platform: [],
  domain: [],
  abtest: null,
  currency: [],
  vip_status: [],
  tags: [],
  btag: [],
};

export const displayConditionInitValues = {
  allow: displayConditionRuleValues,
  deny: displayConditionRuleValues,
};

export const baseDisplayConditionFieldsConfig: DisplayConditionFieldsConfig = {
  userState: {
    fieldName: "user_state",
    label: "User State",
    placeholder: {
      allow: "All",
      deny: "None",
    },
    type: "single",
  },
  userCountry: {
    fieldName: "country",
    label: "Country",
    description:
      "The item will be shown based on user’s country: from profile for logged-in users, from detected location for unlogged users.",
    placeholder: {
      allow: "All",
      deny: "None",
    },
    type: "multiple",
  },
  currentLocale: {
    fieldName: "locale",
    label: "Current Locale",
    placeholder: {
      allow: "All",
      deny: "None",
    },
    type: "multiple",
  },
  devicePlatform: {
    fieldName: "device_platform",
    label: "Device & Platform",
    placeholder: {
      allow: "All",
      deny: "None",
    },
    type: "multiple",
  },
  domainOption: {
    fieldName: "domain",
    label: "Domain Type",
    placeholder: {
      allow: "All",
      deny: "None",
    },
    type: "multiple",
    parser: "intersects_keyed:",
  },
  abTestOption: {
    fieldName: "abtest",
    label: "AB test group",
    placeholder: {
      allow: "All",
      deny: "None",
    },
    type: "single",
  },
  userCurrency: {
    fieldName: "currency",
    label: "Currency",
    placeholder: {
      allow: "All",
      deny: "None",
    },
    type: "multiple",
  },
  vipStatus: {
    fieldName: "vip_status",
    label: "VIP status",
    placeholder: {
      allow: "All",
      deny: "Not Selected",
    },
    type: "multiple",
  },
  userTags: {
    fieldName: "tags",
    label: "Tags",
    description:
      "The item will be displayed based on user's tag, specified in Core.",
    placeholder: {
      allow: "All",
      deny: "None",
    },
    type: "multiple",
    parser: "intersects:",
  },
  bTags: {
    fieldName: "btag",
    label: "Btags",
    placeholder: {
      allow: "All",
      deny: "None",
    },
    type: "multiple",
    parser: "starts_with:",
  },
};
